module.exports = __webpack_public_path__ + "static/shelf_small-2d264f21266cc6e8cd6b5f493dee71a4.webp";